import { Component, Inject, OnInit, Optional, Signal, computed } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@Services/utility.service';


@Component({
    selector: 'app-idler',
    templateUrl: './idler.component.html',
    styleUrls: ['./idler.component.scss'],
    imports: []
})
export class IdlerComponent implements OnInit {
  protected readonly timeLeftFormatted = computed(() =>
    this.uS.secondsToHourMinSec(this.data.timeLeft()),
  );
  protected readonly timeLeftString = computed<string>(() => {
    const { hours, mins, secs } = this.timeLeftFormatted() || {};
    return `${hours ? hours + 'hrs' : ''} ${mins ? mins + 'min' : ''} ${secs ? secs + 's' : ''}`;
  });
  constructor(
    public dialogRef: MatDialogRef<IdlerComponent>, 
    public uS: UtilityService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { timeLeft: Signal<number> },
  ) {}

  ngOnInit(): void {}
  close() {
    this.dialogRef.close();
  }
}
